<style>
  .Men {
    background-color: #7bd5dd !important;
  }

  .Women {
    background-color: #e86c37 !important;
  }
</style>

<h5 *ngIf="KarshnasMasolForm_Edit_Id==-1"> اطلاعات کارشناس/ان </h5>
<h5 *ngIf="KarshnasMasolForm_Edit_Id>-1"> ویرایش اطلاعات کارشناس/ان </h5>

<form [formGroup]="RabetMasolCustomer" (submit)="OnSubmit_KarshnasMasolForm()">

  <input type="hidden" formControlName="id">

  <div class="row">
    <div class="form-group col-md-3">
      <label for="exampleInputEmail1"> نام (*) </label>
      <input formControlName="FName" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
      <small *ngIf="!get_Form_RabetMasol_FName().valid && get_Form_RabetMasol_FName().touched"
        class="form-text text-muted MyErrorRedColor">نام را وارد نمائید.</small>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1"> نام خانوادگی (*) </label>
      <input formControlName="LName" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
      <small *ngIf="!get_Form_RabetMasol_LName().valid && get_Form_RabetMasol_LName().touched"
        class="form-text text-muted MyErrorRedColor">نام خانوادگی را وارد نمائید.</small>
    </div>


    <div class="form-group col-md-3" *ngIf="!Shitch_KarshnasType">
      <label for="exampleInputEmail1">
        <button type="button" (click)="Shitch_KarshnasType_click()" class="btn btn-secondary">
          سمت (برای انتخاب کلید کنید)
        </button>
      </label>
      <input formControlName="Semat" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
      <small *ngIf="!get_Form_RabetMasol_Semat().valid && get_Form_RabetMasol_Semat().touched"
        class="form-text text-muted MyErrorRedColor">سمت را وارد نمائید.</small>
    </div>

    <div class="form-group col-md-3" *ngIf="Shitch_KarshnasType">
      <label for="exampleInputEmail1">
        <button type="button" (click)="Shitch_KarshnasType_click()" class="btn btn-secondary">
          سمت (برای تایپ کلید کنید)
        </button>
      </label>
      <select class="custom-select" formControlName="Semat">
        <option value="">انتخاب کنید</option>
        <option *ngFor="let item of DataList_Semat" [value]="item.title">{{item.title}}</option>
      </select>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">جنسیت</label>
      <select formControlName="Sex" class="custom-select">
        <option value="0">زن</option>
        <option value="1">مرد</option>
      </select>
    </div>


  </div>

  <div class="row">


    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        تلفن
        <button (click)="OnAdd_RabetMasolCustomer_Tel()" type="button"
          [disabled]="!get_Form_RabetMasol_Tel().valid || get_Form_RabetMasol_Tel().value =='' || get_Form_RabetMasol_Mobile().value == null "
          class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
      </label>
      <input type="number" formControlName="Tel" class="form-control" placeholder="اینجا تایپ کنید ...">
      <small *ngIf="!get_Form_RabetMasol_Tel().valid && get_Form_RabetMasol_Tel().touched"
        class="form-text text-muted MyErrorRedColor">تلفن را وارد نمائید.</small>

      <table class="mb-0 table table-bordered table-3 text-center table-striped"
        *ngIf="RabetMasolCustomer_Tel.length>0">
        <tr class="bg-warning" *ngFor="let item of RabetMasolCustomer_Tel">
          <td>
            {{item.title}}
          </td>
          <td>
            <a style="cursor: pointer;" (click)="RabetMasolCustomer_Tel_Delete(item.id)"><i class="fa fa-remove"></i>
              حذف </a>
          </td>
        </tr>
      </table>

    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        تلفن همراه تماس (بدون صفر اول)
      </label>
      <input type="number" formControlName="Mobile" class="form-control" placeholder="اینجا تایپ کنید ...">
      <small *ngIf="!get_Form_RabetMasol_Mobile().valid && get_Form_RabetMasol_Mobile().touched"
        class="form-text text-muted MyErrorRedColor">تلفن همراه تماس را وارد نمائید.</small>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        تلفن همراه جایگزین (بدون صفر اول)
      </label>
      <input type="number" formControlName="jaygozinMiblie" class="form-control" placeholder="اینجا تایپ کنید ...">
      <small *ngIf="!get_Form_RabetMasol_jaygozinMiblie().valid && get_Form_RabetMasol_jaygozinMiblie().touched"
        class="form-text text-muted MyErrorRedColor">تلفن همراه جایگزین را وارد نمائید.</small>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        تلفن همراه فضای مجازی (بدون صفر اول)
      </label>
      <input type="number" formControlName="majaziMobile" class="form-control" placeholder="اینجا تایپ کنید ...">
      <small *ngIf="!get_Form_RabetMasol_majaziMobile().valid && get_Form_RabetMasol_majaziMobile().touched"
        class="form-text text-muted MyErrorRedColor">تلفن همراه فضای مجازی را وارد نمائید.</small>
    </div>

  </div>

  <div class="row">
    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">پیامک</label>
      <select formControlName="SmsActive" class="custom-select">
        <option value="0"> ارسال نشود</option>
        <option value="1"> ارسال شود</option>
      </select>

    </div>
    <div class="form-group col-md-9">
      <label for="exampleInputEmail1"> توضیحات </label>
      <input type="text" formControlName="Dsc" class="form-control" placeholder="اینجا تایپ کنید ...">
    </div>
  </div>


  <button *ngIf="KarshnasMasolForm_Edit_Id==-1" type="submit" [disabled]="!RabetMasolCustomer.valid"
    class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن کارشناس مسئول
  </button>
  <button *ngIf="KarshnasMasolForm_Edit_Id==-1" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
      class="fa fa-times-rectangle"></i> لغو </button>

  <button *ngIf="KarshnasMasolForm_Edit_Id>-1" type="submit" [disabled]="!RabetMasolCustomer.valid" class="btn btn-info"
    style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش کارشناس مسئول </button>
  <button *ngIf="KarshnasMasolForm_Edit_Id>-1" type="button" (click)="KarshnasMasolForm_Edit_Cancel()"
    class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle"></i> لغو ویرایش </button>

</form>

<br />
<br />

<div class="table-responsive" *ngIf="DataList_KarshnasMasol.length>0 && KarshnasMasolForm_Edit_Id==-1">
  <table class="mb-0 table table-bordered table-3 text-center table-striped">
    <thead style="background-color: #489b39; color: white;">
      <tr>
        <th>#</th>
        <th>پیامک</th>
        <th>نام</th>
        <th>نام خانوادگی</th>
        <th>جنسیت</th>
        <th>سمت</th>
        <th>تلفن</th>
        <th>تلفن همراه تماس</th>
        <th>تلفن همراه جایگزین</th>
        <th>تلفن همراه فضای مجازی</th>
        <th>توضیحات</th>
        <th>امکانات</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of DataList_KarshnasMasol" [ngClass]="{'Men': item.sex===1,'Women': item.sex===0}">
        <td>{{DataList_KarshnasMasol.indexOf(item)+1}}</td>
        <td>
          <input type="checkbox" disabled="" [(ngModel)]="item.smsActive" />
        </td>
        <td>{{item.fname}}</td>
        <td>{{item.lname}}</td>
        <td>
          <p *ngIf="item.sex==0">زن</p>
          <p *ngIf="item.sex==1">مرد</p>
        </td>
        <td>{{item.semat}}</td>

        <td>
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.Tel">
              <td>
                {{item.Tel.indexOf(itemDetail)+1}}
              </td>
              <td>
                {{itemDetail.title}}
              </td>
            </tr>
          </table>
        </td>
        <td>{{item.mobile}}</td>
        <td>{{item.jaygozinMiblie}}</td>
        <td>{{item.majaziMobile}}</td>
        <td>{{item.dsc}} </td>
        <td>
          <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
            <div class="btn-group" role="group">
              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                امکانات
              </button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a style="cursor: pointer;" (click)="KarshnasMasolForm_Edit(DataList_KarshnasMasol.indexOf(item))"
                  class="dropdown-item"><i class="fa fa-edit"></i> ویرایش </a>

                <a style="cursor: pointer;" (click)="KarshnasMasolForm_Delete(DataList_KarshnasMasol.indexOf(item))"
                  class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
              </div>
            </div>
          </div>
        </td>

      </tr>
    </tbody>
  </table>
</div>

<br />